import columnAnimation from './column-animation';

export default {
  'initial.dataset.paretoColumn': columnAnimation['initial.dataset.column']
};
